import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import AutorBox from './Autor';
import LivroBox from './Livro';
import Home from './Home';
import './index.css';
import {Route,Router,hashHistory,IndexRoute} from 'react-router';

ReactDOM.render(
  (
  <Router history={hashHistory}>
    <Route path="/" component={App}>
        <IndexRoute component={Home}/>
        <Route path="/autor" component={AutorBox}/>
        <Route path="/livro" component={LivroBox}/>
      </Route>
  </Router>
   ),
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js